<template>
  <div class="layout-viewer">
    <template v-for="card of props.layout" :key="card.id">
      <LayoutItem :layout="card" />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { LayoutCard } from "../utils/layout";
import LayoutItem from "./LayoutItem.vue";

const props = defineProps<{
  layout: LayoutCard[];
}>();
</script>
